import { MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { Control, Controller, FormState } from "react-hook-form";
import { SmallInputLabel } from ".";
import { MEETING_AGENDA_TYPES, MeetingAgendaItemType, MeetingType } from "../constants";

interface ICreateEditAgendaItemFormState {
  name: string;
  description: string;
  allocatedTimeInMinutes: number;
  type: MeetingAgendaItemType;
}

interface IProps {
  formState: FormState<ICreateEditAgendaItemFormState>;
  control: Control<ICreateEditAgendaItemFormState, any>;
  meetingType: MeetingType;
}

const AcceptedNumberInputKeys = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "Tab",
];

const CreateEditAgendaItemForm = (props: IProps) => {
  const {
    formState: { errors },
    control,
  } = props;

  return (
    <Stack spacing={1}>
      <Stack spacing={0.25}>
        <SmallInputLabel>Name *</SmallInputLabel>
        <Controller
          name="name"
          control={control}
          rules={{ required: { message: "Agenda step name is required", value: true } }}
          render={({ field }) => (
            <TextField
              {...field}
              error={errors["name"] !== undefined}
              helperText={errors["name"]?.message}
              placeholder="Enter a name for the agenda step..."
              inputProps={{ maxLength: 64 }}
            />
          )}
        />
      </Stack>
      <Stack spacing={0.25}>
        <SmallInputLabel>Description *</SmallInputLabel>
        <Controller
          name="description"
          control={control}
          rules={{ required: { message: "Description is required", value: true } }}
          render={({ field }) => (
            <TextField
              {...field}
              error={errors["description"] !== undefined}
              helperText={errors["description"]?.message}
              placeholder="Describe the purpose of this agenda step..."
              multiline
            />
          )}
        />
      </Stack>
      <Stack spacing={0.25}>
        <SmallInputLabel>Duration</SmallInputLabel>
        <Controller
          name="allocatedTimeInMinutes"
          control={control}
          render={({ field }) => (
            <Stack direction="row" spacing={0.5} alignItems="center">
              <TextField
                {...field}
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                placeholder="Enter the duration in minutes..."
                //https://github.com/mui/material-ui/issues/10582
                //https://bugzilla.mozilla.org/show_bug.cgi?id=1194812
                onKeyDown={(e) => {
                  if (!AcceptedNumberInputKeys.find((char) => char === e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={{ minWidth: 0 }}
              />
              <Typography variant="caption">Minutes</Typography>
            </Stack>
          )}
        />
      </Stack>
      <Stack spacing={0.25}>
        <SmallInputLabel>Content</SmallInputLabel>
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <Select {...field}>
              {MEETING_AGENDA_TYPES.filter((item) => item.meetingTypeFilter(props.meetingType)).map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </Stack>
    </Stack>
  );
};

export { CreateEditAgendaItemForm };
export type { ICreateEditAgendaItemFormState };
